<div class="modal-header panel-heading">
  <h2 class="modal-title d-flex align-items-center gap-2">
    {{ (extensionMode ? (extension ? "extensions.editTitle" : "extensions.createNewTitle") : (viewOnly ? "tasksPage.contractModal.showContract" : "tasksPage.contractModal.newContract")) | translate }}
    @if (extensionMode && extensionLabel) {
      <span class="extension-chip">{{ extensionLabel }}</span>
    }
  </h2>
  <button type="button" class="close" (click)="close()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">

  @if (isFirstStep) {
    <div class="form-group mt-lg">
      @for (profile of taskProfiles; track profile; let i = $index) {
        <div>
          <input type="checkbox" id="profile{{i}}" style="margin-right: 10px" (change)="onProfileSelected(profile)">
          <label for="profile{{i}}">{{profile.fullname}}</label>
        </div>
      }
      <div class="external-partner-group row">
        <div class="col-6 pl-0">
          <input type="radio" id="external-partner" style="margin-right: 10px;" [value]="true"
            [(ngModel)]="hasByExternalPartner">
          <label for="external-partner">{{"tasksPage.contractModal.partnersWon" | translate}}</label>
        </div>
        @if (hasByExternalPartner) {
          <div class="col-6 pl-0">
            <input type="text" placeholder="Navn på vundet partner" (input)="externalPartner = $event.target.value">
          </div>
        }
      </div>
    </div>
  }

  @if (!isFirstStep) {
    <form [formGroup]="taskContractForm" class="mb-lg">
      <div>
        <div class="form-group mt-lg">
          <div class="row">
            <label class="col-sm-3 control-label text-right">{{"labels.name" | translate}}: </label>
            <div class="col-sm-9">
              <input readonly class="form-control" type="text" formControlName="fullname">
            </div>
          </div>
        </div>
        <div class="form-group mt-lg">
          <div class="row">
            <label class="col-sm-3 control-label text-right">{{"tasksPage.contractModal.companyVat" | translate}}: </label>
            <div class="col-12 col-sm-3">
              <select class="form-control mb-md" [(ngModel)]="isForeignCvr"
                [ngModelOptions]="{standalone: true}" (ngModelChange)="onSelectChange()" required>
                <option [ngValue]="false">DK</option>
                <option [ngValue]="true">{{ "labels.foreign" | translate }}</option>
              </select>
            </div>
            <div class="col-sm-4">
              <input class="form-control" type="text" formControlName="cvr" placeholder="{{ 'placeholders.vat' | translate }}" required>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 control-label text-right"></label>
            <div class="col-sm-7">
              <input class="form-control" type="text" formControlName="businessName" placeholder="{{ 'placeholders.companyName' | translate }}" required>
            </div>
          </div>
        </div>
        <div class="form-group mt-lg">
          <div class="row">
            <label class="col-sm-3 control-label text-right">
              {{ "labels.currency" | translate }}
            </label>
            <div class="col-sm-9">
              <input class="form-control mb-md" type="text" value="DKK" readonly>
            </div>
          </div>
        </div>
        <div class="form-group mt-lg">
          <div class="row">
            <div class="col-sm-9 offset-sm-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="differentCurrency"
                  [(ngModel)]="showCurrencyInfo" [ngModelOptions]="{standalone: true}">
                <label class="form-check-label" for="differentCurrency">
                  {{ 'profilePage.contratAddModal.differentCurrencyCheckbox' | translate }}
                </label>
              </div>
            </div>
          </div>
        </div>
        @if (showCurrencyInfo) {
          <div class="form-group mt-lg">
            <div class="row">
              <label class="col-sm-3 control-label text-right">
                {{ 'profilePage.contratAddModal.altCurrencySelect' | translate }}
              </label>
              <div class="col-sm-9">
                <select class="form-control" [(ngModel)]="altCurrency" [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="onAltCurrencyChange($event)">
                  <option value="">--</option>
                  @for (c of availableCurrencies; track c.code) {
                    <option [value]="c.code">{{ c.code }}</option>
                  }
                </select>
              </div>
            </div>
          </div>
          <div class="form-group mt-lg">
            <div class="row">
              <label class="col-sm-3 control-label text-right">
                {{ 'profilePage.contratAddModal.altExchangeRate' | translate }}
              </label>
              <div class="col-sm-9">
                <input class="form-control" type="text" [value]="altExchangeRate ?? ''" readonly>
              </div>
            </div>
          </div>
          <div class="form-group mt-lg">
            <div class="row">
              <label class="col-sm-3 control-label text-right">
                {{ 'profilePage.contratAddModal.altPrice' | translate }}
              </label>
              <div class="col-sm-9">
                <input class="form-control" type="number" [(ngModel)]="altPrice" [ngModelOptions]="{standalone: true}">
              </div>
            </div>
          </div>
          <div class="form-group mt-lg">
            <div class="row">
              <div class="col-sm-9 offset-sm-3">
                <div class="alert alert-info mb-0">
                  <strong>{{ 'contractsDetails.altCurrencyBox.fixedRatesInfo' | translate }}</strong>
                  <div>{{ 'contractsDetails.altCurrencyBox.fixedRatesEur' | translate }}</div>
                  <div>{{ 'contractsDetails.altCurrencyBox.fixedRatesUsd' | translate }}</div>
                  <div>{{ 'contractsDetails.altCurrencyBox.fixedRatesGbp' | translate }}</div>
                </div>
              </div>
            </div>
          </div>
        }
        <div class="form-group mt-lg">
          <div class="row">
            <label class="col-sm-3 control-label text-right">{{"labels.purchaseSold" | translate}}: </label>
            <div class="col-sm-4">
              <input class="form-control" type="text" formControlName="purchasePrice" required>
            </div>
            <div class="col-sm-4">
              <input class="form-control" type="text" formControlName="soldPrice" required>
            </div>
          </div>
        </div>
        <div class="form-group mt-lg">
          <div class="row">
            <label class="col-sm-3 control-label text-right">{{"labels.margin" | translate}}: </label>
            <div class="col-sm-9">
              <input class="form-control" type="text" formControlName="margin" required>
            </div>
          </div>
        </div>
        <div class="form-group mt-lg">
          <div class="row">
            <label class="col-sm-3 control-label text-right">{{ "labels.travelPrice" | translate }}: </label>
            <div class="col-sm-9">
              <input class="form-control" type="text" formControlName="travelPrice" required>
            </div>
          </div>
        </div>
        <div class="form-group mt-lg">
          <div class="row">
            <label class="col-sm-3 control-label text-right">{{ "labels.overtimePrice" | translate }}: </label>
            <div class="col-sm-9">
              <input class="form-control" type="text" formControlName="overtimePrice" required>
            </div>
          </div>
        </div>
        <div class="form-group mt-lg">
          <div class="row">
            <label class="col-sm-3 control-label text-right">{{ "labels.costPrice" | translate }}: </label>
            <div class="col-sm-9">
              <input class="form-control" type="text" formControlName="costPrice" required>
            </div>
          </div>
        </div>
        <div class="form-group mt-lg">
          <div class="row">
            <label class="col-sm-3 control-label text-right">{{ "labels.startEndDate" | translate }}: </label>
            <div class="col-sm-4">
              <input class="date form-control" (click)="d.toggle()" tabindex="7"
                style="background-color: white;" ngbDatepicker #d="ngbDatepicker" [readonly]="true"
                formControlName="startDate" required>
            </div>
            <div class="col-sm-4">
              <input class="date form-control" (click)="d2.toggle()" tabindex="7"
                style="background-color: white;" ngbDatepicker #d2="ngbDatepicker" [readonly]="true"
                formControlName="endDate" required>
            </div>
          </div>
        </div>
        <div class="form-group mt-lg">
          <div class="row">
            <label class="col-sm-3 control-label text-right">{{ "labels.hours" | translate }}:</label>
            <div class="col-sm-9">
              <textarea style="resize: none;" [placeholder]="'placeholders.hoursPerWeekOrPeriod' | translate" class="form-control resize-none"
              type="text" formControlName="weeklyHours" required></textarea>
            </div>
          </div>
        </div>
        <div class="form-group mt-lg">
          <div class="row">
            <label class="col-sm-3 control-label text-right">{{ "labels.taskDescription" | translate }}</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" formControlName="description" required>
            </div>
          </div>
        </div>
        <div class="form-group mt-lg">
          <div class="row">
            <label class="col-sm-3 control-label text-right">{{ "labels.accountType" | translate }}</label>
            <div class="col-sm-3">
              <label style="padding-right: 10px;" for="danish-radio">{{ "labels.danish" | translate }}</label>
              <input value="danish" type="radio" id="danish-radio" formControlName="accountType"
                (change)="onAccountTypeChanged($event)">
            </div>
            <div class="col-sm-3">
              <label style="padding-right: 10px;" for="foreign-radio">{{ "labels.foreign" | translate
              }}</label>
              <input value="foreign" type="radio" id="foreign-radio" formControlName="accountType"
                (change)="onAccountTypeChanged($event)">
            </div>
          </div>
        </div>
        @if (isAccountDanish) {
          <div class="form-group mt-lg">
            <div class="row">
              <label class="col-sm-3 control-label text-right">{{ "labels.regAccount" | translate }}: </label>
              <div class="col-sm-3">
                <input class="form-control" type="text" formControlName="reg" required minlength="4"
                  maxlength="4">
              </div>
              <div class="col-sm-6">
                <input class="form-control" type="text" formControlName="account" required>
              </div>
            </div>
          </div>
        } @else {
          <div class="form-group mt-lg">
            <div class="row">
              <label class="col-sm-3 control-label text-right">{{ "labels.ibanSwift" | translate }}:</label>
              <div class="col-sm-4">
                <input class="form-control" type="text" formControlName="iban" required>
              </div>
              <div class="col-sm-4">
                <input class="form-control" type="text" formControlName="swift" required>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="form-group mt-lg">
        <div class="row">
          <label class="col-sm-3 control-label text-right">{{ "labels.optionMonth" | translate }}</label>
          <div class="col-sm-9">
            <select class="form-control mb-md" formControlName="option" (change)="onSelectChange()">
              <option [ngValue]="null" data-default>{{"labels.chooseMonthExtension" | translate}}</option>
              @for (index of months; track index) {
                <option [value]="index">{{index}}</option>
              }
            </select>
          </div>
        </div>
      </div>
      <div class="form-group mt-lg">
        <div class="row">
          <label class="col-sm-3 control-label text-right">{{ "labels.paymentTerms" | translate }}</label>
          <div class="col-sm-3">
            <label style="padding-right: 10px;" for="terms-p-yes">{{ "labels.yes" | translate }}</label>
            <input value="yes" type="radio" id="terms-p-yes" formControlName="paymentTerms">
          </div>
          <div class="col-sm-3">
            <label style="padding-right: 10px;" for="terms-p-no">{{ "labels.no" | translate }}</label>
            <input value="no" type="radio" id="terms-p-no" formControlName="paymentTerms">
          </div>
        </div>
      </div>
      <div class="form-group mt-lg">
        <div class="row">
          <label class="col-sm-3 control-label text-right">{{ "labels.equipment" | translate }}</label>
          <div class="col-sm-3">
            <label style="padding-right: 10px;" for="equipment-p-own">{{ "profilePage.contratAddModal.own" | translate }}</label>
            <input value="own" type="radio" id="equipment-p-own" formControlName="equipment">
          </div>
          <div class="col-sm-3">
            <label style="padding-right: 10px;" for="equipment-p-customer">{{ "profilePage.contratAddModal.providedByCustomer" | translate }}</label>
            <input value="customer" type="radio" id="equipment-p-customer" formControlName="equipment">
          </div>
        </div>
      </div>
      <div class="form-group mt-lg">
        <div class="row">
          <label class="col-sm-3 control-label text-right">{{"tasksPage.contractModal.upstartPackage" |
          translate}}</label>
          <div class="col-sm-3">
            <label style="padding-right: 10px;" for="package-yes">{{ "labels.yes" | translate }}</label>
            <input value="yes" type="radio" id="package-yes" formControlName="startupPackage">
          </div>
          <div class="col-sm-3">
            <label style="padding-right: 10px;" for="package-no">{{ "labels.no" | translate }}</label>
            <input value="no" type="radio" id="package-no" formControlName="startupPackage">
          </div>
        </div>
      </div>
    </form>
  }
</div>
<div class="modal-footer panel-footer">
  <button class="btn modal-dismiss" (click)="close()" aria-label="Close">{{"labels.cancel" | translate}}</button>
  @if (!isFirstStep && !isEditMode && !extensionMode) {
    <button (click)="onPrevClicked()" class="btn">{{"labels.back" | translate}}</button>
  }
  @if (!isLastStep && !extensionMode) {
    <button (click)="onNextClicked()" class="btn">{{"labels.next" | translate}}</button>
  }
  @if (isLastStep && !isEditMode && !extensionMode) {
    <button (click)="onSaveContractClicked()" class="btn">{{"labels.saveContracts" |
    translate}}</button>
  }
  @if (extensionMode) {
    <button (click)="onSaveContractClicked()" class="btn">{{ (extension ? "labels.save" : "extensions.create") | translate }}</button>
  }
</div>